import { render, staticRenderFns } from "./MyVip.vue?vue&type=template&id=fd98bf60"
import script from "./MyVip.vue?vue&type=script&lang=js"
export * from "./MyVip.vue?vue&type=script&lang=js"
import style0 from "./MyVip.vue?vue&type=style&index=0&id=fd98bf60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports